// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"caefa0d5","239":"a80d4084","667":"65492e15"}[chunkId] + ".chunk.js";
};